<div class="menu-icon" [ngClass]="isActive?'active':''" (click)="toggleMenuHamburger()">
    <div class="line-1 "></div>
    <div class="line-2 "></div>
    <div class="line-3 "></div>
</div>